import { MenuItemProps } from 'features/footer/components/MenuItem';
import {
  createFeatureMenuItem,
  generateBadgeState,
  generateFeaturePath,
  getSortedVisibleFeatures
} from 'features/footer/utils';
import { Feature, FEATURE_DIGICLUEPLUS_SIMPLE_COUPONS } from 'libs/features';
import {
  couponStateAtom,
  membershipSettingAtom,
  unreadNotificationAtom
} from 'libs/recoil/atom';
import {
  activeFeatureCodesState,
  activeFeaturesState
} from 'libs/recoil/selector';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useFetchCouponState } from './useFetchCouponState';
import { footerSettingAtom, useSetFooterSetting } from './useSetFooterSetting';

export const useFooterFeatureMenus = (): MenuItemProps[] => {
  const navigate = useNavigate();
  useSetFooterSetting();

  // Recoilの値を一括取得
  const {
    features,
    activeFeatureCodes,
    aliasCode,
    notificationState,
    couponState,
    footerSetting
  } = useRecoilValues();

  // クーポン状態を取得
  useFetchCouponState({
    enabled:
      activeFeatureCodes.includes(FEATURE_DIGICLUEPLUS_SIMPLE_COUPONS.id) &&
      !couponState.loaded,
    delay: 1500
  });

  return useMemo(() => {
    const badges = generateBadgeState({ notificationState, couponState });
    let visibleFeatures: Feature[] = [];
    if (footerSetting.loaded) {
      visibleFeatures = getSortedVisibleFeatures(
        features,
        footerSetting.setting.navis
      );
    }

    return visibleFeatures.map((feature) => {
      const navigatePath = generateFeaturePath({
        feature,
        context: { aliasCode }
      });
      return createFeatureMenuItem({
        feature,
        badges,
        navigate,
        navigatePath,
        throttleMs: 1500
      });
    });
  }, [
    features,
    footerSetting.loaded,
    footerSetting.setting.navis,
    aliasCode,
    notificationState,
    couponState,
    navigate
  ]);
};

// Recoilの値を一括取得するカスタムフック
const useRecoilValues = () => {
  const features = useRecoilValue(activeFeaturesState);
  const activeFeatureCodes = useRecoilValue(activeFeatureCodesState);
  const {
    page_template: { alias_code: aliasCode }
  } = useRecoilValue(membershipSettingAtom);
  const notificationState = useRecoilValue(unreadNotificationAtom);
  const couponState = useRecoilValue(couponStateAtom);
  const footerSetting = useRecoilValue(footerSettingAtom);

  return {
    features,
    activeFeatureCodes,
    aliasCode,
    notificationState,
    couponState,
    footerSetting
  };
};
